/**
 * @generated SignedSource<<b3a56daca7d460a114f8f1214faa0e27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assigned"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "folderId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "onlyUnread"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wChannelIds"
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "assigned",
      "variableName": "assigned"
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    },
    {
      "items": [
        {
          "kind": "Variable",
          "name": "folderIds.0",
          "variableName": "folderId"
        }
      ],
      "kind": "ListValue",
      "name": "folderIds"
    },
    {
      "kind": "Variable",
      "name": "onlyUnread",
      "variableName": "onlyUnread"
    },
    {
      "kind": "Variable",
      "name": "search",
      "variableName": "search"
    },
    {
      "kind": "Variable",
      "name": "wChannelIds",
      "variableName": "wChannelIds"
    }
  ],
  "concreteType": "ThreadConnection",
  "kind": "LinkedField",
  "name": "threads",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ThreadsSelectAllCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ThreadsSelectAllCountQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "330b6108ac0cc6e3f0e382692355def6",
    "id": null,
    "metadata": {},
    "name": "ThreadsSelectAllCountQuery",
    "operationKind": "query",
    "text": "query ThreadsSelectAllCountQuery(\n  $search: String\n  $folderId: ID\n  $wChannelIds: [ID]\n  $assigned: Boolean\n  $onlyUnread: Boolean\n) {\n  userViewer {\n    threads(search: $search, folderIds: [$folderId], wChannelIds: $wChannelIds, first: 1, assigned: $assigned, onlyUnread: $onlyUnread) {\n      pageInfo {\n        totalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "73cd4b885dd94b5fc48434c1ab8e455d";

module.exports = node;
